module.exports = __webpack_public_path__ + "img/list_zoom.63dd0157.webp";